import { useContext } from 'react'
import { IndexContext } from '~/components/index/context'

/**
 * A React hook to retrieve index state
 */
export function useIndexContext () {
  return useContext(IndexContext)
}
